import { ErrorBoundary } from '@sentry/react';
import { ReactNode } from 'react';
import { StatusTranslationKey } from '@/types/status';
import { ContentState } from '../contentState/ContentState';
import { TableWrapper } from './TableWrapper';

export const AggsTableErrorFallback = ({ children }: { children: ReactNode }) => (
  <ErrorBoundary
    fallback={
      <TableWrapper>
        <ContentState status={StatusTranslationKey.ERROR} />
      </TableWrapper>
    }
  >
    {children}
  </ErrorBoundary>
);
